import { render } from "./ModelChart.vue?vue&type=template&id=5a47573d&scoped=true&ts=true"
import script from "./ModelChart.vue?vue&type=script&lang=ts"
export * from "./ModelChart.vue?vue&type=script&lang=ts"

import "./ModelChart.vue?vue&type=style&index=0&id=5a47573d&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a47573d"]])

export default __exports__